<template>
  <el-container class="fullheight" style="border: 1px solid #eee">
    <eco-menu-manager ref="ecoMenuManager" @node-click="handleNodeClick" :showEdit="false" node-key="id" @menu-action="menuAction" />
    <el-container v-if="editMenuFormVisible">
      <el-header>
        <fe-submit-button
          url="/sys/sysMenu/v1/save"
          context="portal"
          :model="menu"
          scope-name="editMenuForm"
          class="marginTop16 marginLeft16"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveData"
          v-if="!menu.id || $store.state.login.currentUser.tenantId == menu.tenantId"
          >{{ menu.id ? '更新' : '保存' }}</fe-submit-button
        >
      </el-header>
      <el-main>
        <el-form data-vv-scope="editMenuForm" :model="menu" size="mini" :inline="true">
          <div style="width: 1000px">
            <el-row>
              <el-col :span="12">
                <eco-form-item v-if="hasParent" label="上级菜单" label-width="150px">
                  <eco-input name="parent-menu-name" v-model="currentNodeData.name" autocomplete="off" disabled></eco-input>
                </eco-form-item>
              </el-col>
              <el-col :span="12">
                <eco-form-item v-if="hasParent" label="上级菜单别名" label-width="150px">
                  <eco-input name="parent-menu-alias" v-model="currentNodeData.alias" autocomplete="off" disabled></eco-input>
                </eco-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <eco-form-item label="菜单名称" label-width="150px">
                  <eco-input name="menu-name" v-model="menu.name" autocomplete="off" :validate="'required'"></eco-input>
                </eco-form-item>
              </el-col>
              <el-col :span="12">
                <eco-form-item label="别名" label-width="150px">
                  <eco-input
                    name="menu-alias"
                    v-model="menu.alias"
                    :disabled="menu.id ? true : false"
                    autocomplete="off"
                    :validate="'required|isExist:${portal}/sys/sysMenu/v1/isMenuExistByAlias?alias=,' + menu.id"
                  ></eco-input>
                </eco-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <eco-form-item label="菜单类型" label-width="150px">
                  <el-radio-group v-model="menu.menuType">
                    <el-radio-button label="0">常规菜单</el-radio-button>
                    <el-radio-button label="1">按钮菜单</el-radio-button>
                    <el-radio-button label="2">工具菜单</el-radio-button>
                  </el-radio-group>
                </eco-form-item>
              </el-col>
              <el-col :span="12">
                <eco-form-item label="排序" label-width="150px">
                  <eco-input name="menu-sn" v-model="menu.sn" autocomplete="off" validate="required|numeric"></eco-input>
                </eco-form-item>
              </el-col>
            </el-row>
            <el-row v-show="menu.menuType == 0 || menu.menuType == 2">
              <el-col :span="24">
                <eco-form-item label="图标" label-width="150px">
                  <el-row>
                    <el-col :span="4"> Pc </el-col>
                    <el-col :span="20">
                      <eco-input name="menu-icon" v-model="menu.menuIcon" autocomplete="off" style="width: 650px"></eco-input>
                    </el-col>
                  </el-row>
                  <el-row style="margin-top: 5px">
                    <el-col :span="4"> App </el-col>
                    <el-col :span="20">
                      <eco-input name="menu-icon" v-model="menu.menuIconApp" autocomplete="off" style="width: 650px"></eco-input>
                    </el-col>
                  </el-row>
                </eco-form-item>
              </el-col>
            </el-row>
            <el-row v-show="menu.menuType == 0">
              <el-col :span="24">
                <eco-form-item label="路由" label-width="150px">
                  <el-row>
                    <el-col :span="4"> Pc </el-col>
                    <el-col :span="20">
                      <eco-input name="menu-icon" v-model="menu.routePc" autocomplete="off" style="width: 650px"></eco-input>
                    </el-col>
                  </el-row>
                  <el-row style="margin-top: 5px">
                    <el-col :span="4"> App </el-col>
                    <el-col :span="20">
                      <eco-input name="menu-icon" v-model="menu.routeApp" autocomplete="off" style="width: 650px"></eco-input>
                    </el-col>
                  </el-row>
                </eco-form-item>
              </el-col>
            </el-row>
            <el-row v-show="menu.menuType == 0 || menu.menuType == 2">
              <el-col :span="24">
                <eco-form-item label="外部" label-width="150px">
                  <el-row>
                    <el-col :span="4"> 方式 </el-col>
                    <el-col :span="20">
                      <el-radio-group v-model="menu.hrefType">
                        <el-radio-button label="1">内嵌系统</el-radio-button>
                        <el-radio-button label="2">外链系统</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row style="margin-top: 5px">
                    <el-col :span="4"> 地址 </el-col>
                    <el-col :span="20">
                      <eco-input name="menu-href" v-model="menu.href" style="width: 650px"></eco-input>
                    </el-col>
                  </el-row>
                </eco-form-item>
              </el-col>
            </el-row>
            <el-row v-show="menu.menuType == 2">
              <el-col :span="24">
                <eco-form-item label="上传图标" label-width="150px">
                  <FeFileToUpload ref="manageLogo" model-name="menu.uploadIcon" :accept="`.jpg,.jpeg,.png,.JPG,.JPEG`" :limit="1" :multiple="false">
                  </FeFileToUpload>
                </eco-form-item>
              </el-col>
            </el-row>
            <!--            <el-row v-show="menu.menuType === 0">-->
            <!--              <el-col :span="24">-->
            <!--                <eco-form-item label="仪表盘认证" label-width="150px">-->
            <!--                  <eco-input-->
            <!--                      name="menu-dashboard"-->
            <!--                      v-model="menu.dashboardAuth"-->
            <!--                      style="width:690px"-->
            <!--                  ></eco-input>-->
            <!--                </eco-form-item>-->
            <!--              </el-col>-->
            <!--            </el-row>-->
          </div>

          <el-table :data="menu.sysMethods" style="width: 100%" v-show="menu.menuType == 0 || menu.menuType == 1">
            <el-table-column prop="name" label width="180">
              <template slot="header">
                <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addSysMethods" title="添加接口"></el-button
                ><span class="is-required">请求方法描述</span>
              </template>
              <template slot-scope="scope">
                <eco-input v-model="scope.row.name" autocomplete="off" validate="required" placeholder="方法描述" @focus="showDialog2(scope.$index)" />
                <eco-dialog
                  :data="jiekou"
                  :single="true"
                  :table-columns="tableColumns"
                  :pagination="pagination1"
                  search-placeholder="名称"
                  dialog-title="接口方法选择"
                  quick-search-props="NAME_"
                  :append-to-body="true"
                  :destroy-on-close="true"
                  @load="handleLoad"
                  @onConfirm="onConfirm"
                  ref="ecoDialog"
                />
              </template>
            </el-table-column>
            <el-table-column prop="alias" label width="180">
              <template slot="header">
                <span class="is-required">别名</span>
                <el-tooltip content="别名为字母数字组合，且以字母开头，不能包括特殊字符" placement="right">
                  <i class="icon-question" style="margin-right: 8px" />
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <eco-input
                  v-model="menu.sysMethods[scope.$index].alias"
                  :model-expression="'menu.sysMethods[' + scope.$index + '].alias'"
                  v-pinyin="menu.sysMethods[scope.$index].name"
                  autocomplete="off"
                  :validate="{
                    required: true,
                    regex: {
                      exp: '^[a-zA-z][a-zA-z0-9]+$',
                      message: '别名有误'
                    }
                  }"
                  disabled
                ></eco-input>
              </template>
            </el-table-column>
            <el-table-column prop="actionType" label width="180">
              <template slot="header">
                <span class="is-required">请求方法名</span>
              </template>
              <template slot-scope="scope">
                <eco-input
                  v-model="menu.sysMethods[scope.$index].actionType"
                  :model-expression="'menu.sysMethods[' + scope.$index + '].actionType'"
                  disabled
                ></eco-input>
              </template>
            </el-table-column>
            <el-table-column prop="requestUrl" label width="auto">
              <template slot="header">
                <span class="is-required">后台请求地址</span>
                <el-tooltip content="请求地址必须以/开头,并且只能包括英文、数字和/" placement="right">
                  <i class="icon-question" style="margin-right: 8px" />
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <eco-input
                  v-model="scope.row.requestUrl"
                  style="width: 90%"
                  autocomplete="off"
                  disabled
                  :validate="{
                    required: true,
                    regex: {
                      exp: '^/[a-zA-Z0-9\\\\\\/\\+]+$',
                      message: '请求地址输入有误'
                    }
                  }"
                  placeholder="请输入后台请求地址"
                ></eco-input>
                <el-button type="danger" icon="el-icon-delete" circle @click="removeSysMethod(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-main>
    </el-container>
    <el-dialog width="400px" top="8vh" title="菜单移动" :visible="handleDialog" :before-close="handleClose" :close-on-click-modal="false" append-to-body>
      <el-scrollbar>
        <eco-tree
          style="height: 500px"
          :data="treeMenuData"
          :props="defaultMenuProps"
          @node-click="handleMenuNodeClick"
          :expand-on-click-node="false"
          ref="ecoTypeTree"
        ></eco-tree>
      </el-scrollbar>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">确 定</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </div>
    </el-dialog>
    <el-container v-show="!editMenuFormVisible">
      <div class="form-empty">请选择一个菜单进行操作</div>
    </el-container>
  </el-container>
</template>
<script>
import portalApi from '@/api/portal.js'
import form from '@/api/form.js'
import req from '@/request.js'
import IconDialog from '@/components/dialog/IconDialog.vue'
const FeFileToUpload = () => import('@/components/common/FeFileToUpload.vue')
const EcoMenuManager = () => import('@/components/system/FeMenuManager.vue')
const EipSysTypeSelector = () => import('@/components/selector/EipSysTypeSelector.vue')
export default {
  name: 'MenuManager',
  components: {
    EcoMenuManager,
    EipSysTypeSelector,
    FeFileToUpload,
    IconDialog
  },
  data() {
    return {
      isFrontMenu: false, //是否是添加前端下级菜单
      isHref: false, //是否是添加URL菜单
      editMenuFormVisible: false,
      treeMenuData: [],
      tableColumns: [
        { prop: 'NAME_', label: '名称' },
        { prop: 'ALIAS_', label: '别名' },
        { prop: 'ACTION_TYPE_', label: '请求类别' },
        { prop: 'REQUEST_URL_', label: '请求地址' }
      ],
      jiekou: [],
      pagination1: {
        page: 1,
        pageSize: 50,
        total: 0,
        showTotal: true
      },
      defaultMenuProps: {
        children: 'children',
        label: 'name'
      },
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      index: null,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      handleDialog: false,
      dialogVisible: false,
      menu: {
        alias: '',
        tabsStyle: '',
        sysMethods: [],
        open: true,
        href: '',
        hrefType: 1,
        menuType: 0,
        dashboard: '',
        dashboardAuth: '',
        routePc: '',
        routeApp: ''
      },
      tabsStyle: { tabType: null },
      currentNodeData: {},
      hasParent: false,
      commandData: null
    }
  },
  methods: {
    showDialog2(index) {
      this.index = null
      this.index = index
      this.$refs.ecoDialog.showDialog()
    },
    async handleLoad(param, cb) {
      const url = '${form}/form/customDialog/v1/getListData?alias=jkffxz&mapParam='
      const r = await req
        .request({
          url: url,
          method: 'POST',
          data: param
        })
        .finally(() => cb && cb())
      if (r && r.data) {
        this.jiekou = r.data.rows
        if (this.jiekou && this.jiekou.length > 0) {
          this.jiekou.forEach((ele) => {
            if (ele.NAME_) {
              ele.name = ele.NAME_
            }
            if (ele.ID_) {
              ele.id = ele.ID_
            }
          })
        }
        this.pagination1.page = r.data.page
        this.pagination1.pageSize = r.data.pageSize
        this.pagination1.total = r.data.total
      }
    },
    onConfirm(selection) {
      this.menu.sysMethods[this.index].name = selection[0].NAME_
      this.menu.sysMethods[this.index].alias = selection[0].ALIAS_
      this.menu.sysMethods[this.index].actionType = selection[0].ACTION_TYPE_
      this.menu.sysMethods[this.index].requestUrl = selection[0].REQUEST_URL_
      this.menu.sysMethods[this.index].actionId = selection[0].ID_
    },
    //移动菜单确认事件
    handleSave() {},
    handleMenuNodeClick(node) {},
    handleClose() {
      this.handleDialog = false
    },
    icons(icon) {
      this.menu.menuIcon = icon
    },
    async handleNodeClick(data) {
      if (data.href) {
        this.isHref = true
      } else {
        this.isHref = false
      }
      this.getEditData(data)
      this.currentNodeData = data
      this.commandData = data
    },
    menuAction(command) {
      //判断是否是添加前端下级菜单
      if (command.node.key == '3' && command.action != 'addHref') {
        this.isFrontMenu = true
      } else {
        this.isFrontMenu = false
      }
      //判断是否是添加URL菜单
      if (command.action == 'addHref') {
        this.isHref = true
      } else if (command.action == 'edit' && command.href) {
        this.isHref = true
      } else {
        this.isHref = false
      }
      this.action = command.action
      this.editMenuFormVisible = false
      let node = command.node
      let data = command.data
      this.commandData = command.data
      let action = command.action
      this.currentNodeData = data
      this.menu = {
        ...this.menu,
        ...{
          hrefType: 1,
          href: '',
          name: '',
          alias: '',
          menuIcon: '',
          menuIconApp: '',
          sn: '',
          activeTab: '',
          tabsStyle: '',
          sysMethods: [],
          menuType: 0,
          dashboard: '',
          dashboardAuth: '',
          routePc: '',
          routeApp: ''
        }
      }
      delete this.menu.tenantId
      switch (action) {
        case 'add':
          this.menu.id = ''
          this.menu.parentId = data.id
          this.hasParent = true
          this.menu.path = data.path
          this.editMenuFormVisible = true
          this.tabsStyle = { tabType: null }
          break
        case 'addHref':
          const key = Date.parse(new Date()) + '_' + Math.ceil(Math.random() * 99999)
          this.menu.alias = 'href/template/' + key
          this.menu.id = ''
          this.menu.parentId = data.id
          this.hasParent = true
          this.menu.path = data.path
          this.editMenuFormVisible = true
          this.tabsStyle = { tabType: null }
          break
        case 'edit':
          this.getEditData(data)
          break
        case 'delete':
          this.$confirm(`是否删除菜单[${data.name}]?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          })
            .then(() => {
              this.removeMenuById(data)
            })
            .catch(() => {})
          break
        case 'moveto':
          portalApi.getMenuTree().then((data) => {
            this.handleDialog = true
            this.treeMenuData = data
          })
          // this.$message("暂未提供该功能");
          break
        default:
          break
      }
    },
    getEditData(data) {
      this.editMenuFormVisible = false
      this.hasParent = false
      this.$http.get('${portal}/sys/sysMenu/v1/getJson?id=' + data.id).then((response) => {
        this.menu = response.data
        this.editMenuFormVisible = true
        this.$validator.validate()
        if (this.menu.tabsStyle) {
          this.tabsStyle = JSON.parse(this.menu.tabsStyle)
        } else {
          this.tabsStyle = { tabType: null }
        }
        let _this = this
        setTimeout(function () {
          if (_this.menu.uploadIcon) {
            _this.$refs.manageLogo.setFiles(JSON.parse(_this.menu.uploadIcon))
          }
        }, 200)
      })
    },
    removeMenuById(menu) {
      let params = Object.assign({}, menu)
      portalApi.removeMenuById(menu.id).then(
        () => {
          portalApi.getMenuTreeByParentId(params).then((data) => {
            let transData = data.length ? data[0].children : []
            this.$refs.ecoMenuManager.$refs.ecoMenuTree.updateNode(menu.parentId, transData)
          })
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
        },
        (error) => {}
      )
    },
    beforeSaveData() {
      if (this.tabsStyle.tabType) {
        this.menu.tabsStyle = JSON.stringify(this.tabsStyle)
      }
      if (this.$refs.manageLogo.getFiles() != '') {
        this.menu.uploadIcon = JSON.stringify(this.$refs.manageLogo.getFiles())
      } else {
        this.menu.uploadIcon = ''
      }
    },
    afterSaveData() {
      this.editMenuFormVisible = false
      let params = Object.assign({}, this.menu)
      portalApi.getMenuTreeByParentId(params).then((data) => {
        let transData = data.length ? data[0].children : []
        this.$refs.ecoMenuManager.$refs.ecoMenuTree.updateNode(this.menu.parentId, transData)
      })
      // if (!this.menu.id) {
      //   this.menu = {
      //     ...this.menu,
      //     ...{
      //       href: "",
      //       name: "",
      //       alias: "",
      //       menuIcon: "",
      //       sn: "",
      //       activeTab: "",
      //       tabsStyle: "",
      //       sysMethods: []
      //     }
      //   };
      // }
    },
    addSysMethods() {
      this.menu.sysMethods.push({ name: '', alias: '', requestUrl: '' })
    },
    removeSysMethod(row) {
      this.menu.sysMethods.remove(row)
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .error-small {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 0;
  margin-top: 0;
  position: absolute;
  top: 80%;
  left: 0;
}
>>> .el-table td,
th {
  padding: 13px 0;
}

>>> .el-form-item__content {
  width: 250px;
}

.form-empty {
  position: absolute;
  text-align: center;
  width: 300px;
  font-size: 20px;
  top: 200px;
  left: 50%;
  margin-left: -150px;
  color: #ccc;
}
</style>
